import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/farbin-redis-build.wLbAye/src/app/components/HomePage.tsx");
